<!--
 * @Author: RYL
 * @Description: 
 * @Date: 2020-10-13 08:58:58
 * @LastEditTime: 2022-03-24 19:18:47
-->
<template>
  <div>
    <div style="margin-bottom: 20px">
      <el-button
        v-if="Permission.indexOf(238) !== -1"
        type="primary"
        size="mini"
        @click="addTerminal"
      >{{$t('lang.terminalList.add')}}</el-button>
      <el-button v-if="this.seek.deviceId" type="primary" size="mini" @click="goBack">{{$t('lang.terminalList.returntodevicelist')}}</el-button>
    </div>
    <TableComponent
      :Columns="Columns"
      :data="terminalList"
      :ColuumnsButton="ColuumnsButton"
      :ColuumnsButtonWidth="240"
      @editTerminal="editTerminal"
      @addTerminal="addTerminal"
      @GetStatus="GetStatus"
      @deleteTerminal="deleteTerminal"
      @showDetail="showDetail"
      @sortChange="sortChange"
      @showVariable="showVariable"
      :seek="seek"
    >
      <span
        slot="slot"
        slot-scope="scope"
        style="color:#409eff;font-size:15px;"
      >{{ scope.scope.$index }}</span>
      <span
        slot="customColumn"
        slot-scope="scope"
        style="font-size:15px;"
      >{{ protocolOptions[scope.scope.row.protocol.toString()] }}</span>
    </TableComponent>
    <pagination
      :total="total"
      :offset="offset"
      :limit="limit"
      @SizeChanges="SizeChanges"
      @CurrentChanges="CurrentChanges"
    ></pagination>
    <!-- 增加终端设备 -->
    <cont-dialog ref="contDialog" @updateList="queryKeyword"></cont-dialog>
    <!-- 终端详情 -->
    <show-detail ref="showDetail"></show-detail>
  </div>
</template>
<script>
import { PublicComponent } from "@/mixins/common"
import pagination from "@/components/pagination"
import TableComponent from '@/components/TableComponent/index'
import { Columns, ColuumnsButton } from './tableConfig'
import contDialog from './components/contDialog'
import {
  getTerminalList, deleteTerminal, terminalDetail,
  getByDevice, monitorTerminal, queryTerminal
} from '@/api/cloudMonitor/terminalList'
import showDetail from './components/showDetail'
import { mapGetters } from 'vuex'
import { getPermission } from '@/cookie/cookie'
export default {
  name: 'CloudMonitorTerminalList',
  components: {
    TableComponent,
    pagination,
    contDialog,
    showDetail,
  },
  mixins: [PublicComponent],
  data() {
    return {
      type: 'add', // 判断是添加还是编辑操作
      dialogVisible: false, // 增加编辑弹窗
      editItem: {}, // 编辑项
      Columns,
      ColuumnsButton,
      terminalList: [],
      seek: {
        name: '',
        did: '',
        sortNum: '',
        deviceId: '',
        mname: '',
      },
      // 协议
      protocolOptions: {
        '1': 'Modbus TCP',
        '2': 'Modbus RTU',
        '3': 'IO Control',
      },
      Permission: [],
    }
  },
  activated() {
    if (this.terminalDevice) {
      this.seek.deviceId = this.terminalDevice.deviceId
    } else {
      this.seek.deviceId = ''
    }
    this.queryKeyword()
    this.Permission = getPermission()
  },
  beforeDestroy() {
    this.$store.dispatch('setDevice', '')
  },
  computed: {
    ...mapGetters(['terminalDevice']),
  },
  mounted() {
    if (this.terminalDevice) {
      this.seek.deviceId = this.terminalDevice.deviceId
    } else {
      this.seek.deviceId = ''
    }
    this.queryKeyword()
    this.Permission = getPermission()
  },
  methods: {
    queryKeyword() {
      let params = {
        current: this.offset,
        size: this.limit,
        name: this.seek.name ? this.seek.name : undefined,
        dsn: this.seek.dsn ? this.seek.dsn : undefined,
        protocol: this.seek.protocol ? this.seek.protocol : undefined,
        did: this.seek.did ? this.seek.did : undefined,
        sortNum: this.seek.sortNum ? this.seek.sortNum : undefined,
        deviceId: this.seek.deviceId ? this.seek.deviceId : undefined,
        mname: this.seek.mname ? this.seek.mname : undefined
      }
      queryTerminal(params).then(res => {
        if (res.data.code === 0) {
          let data = res.data.data
          this.terminalList = data.records
          this.terminalList.unshift({})
          this.total = data.total
        } else {
          this.$message.error(this.$t('lang.terminalList.Requestfailed'))
        }
      }).catch(() => {
        this.$message.error(this.$t('lang.terminalList.Requestfailed'))
      })
    },
    editTerminal(row) {
      this.$refs.contDialog.show(row.id, 'edit')
    },
    addTerminal() {
      this.$refs.contDialog.show(this.terminalDevice, 'add')
    },
    // 查看终端详情
    showDetail(row) {
      this.$refs.showDetail.show(row.id)
    },
    deleteTerminal(row) {
      let data = {}
      if (row.protocol == 1) {
        data = {
          id: row.id,
          dsn: row.dsn,
          protocol: row.protocol,
          tcpProtocol: {
            id: row.pid
          }
        }
      } else if (row.protocol == 2) {
        data = {
          id: row.id,
          dsn: row.dsn,
          protocol: row.protocol,
          rtuProtocol: {
            id: row.pid
          }
        }
      } else if (row.protocol == 3) {
        data = {
          id: row.id,
          dsn: row.dsn,
          protocol: row.protocol,
        }
      }
      deleteTerminal(data).then(res => {
        if (res.data.code === 0) {
          let params = {
            dtuId: row.id,
            action: 2
          }
          monitorTerminal(params).then(res => {
            if (res.data.code === 0) {
              this.$message.success(this.$t('lang.Button.successDelete'))
            } else {
              this.$message.warning(this.$t('lang.terminalList.Terminalinformation'))
            }
          }).catch(() => {
            this.$message.error(this.$t('lang.terminalList.collectionrequesterror'))
          })
          this.offset = 1
          this.queryKeyword()
        } else {
          this.$message.error(this.$t('lang.Button.failDelete'))
        }
      }).catch(() => { })
      // monitorTerminal({dtuId:row.id,action: 2}).then(res=>{
      //   console.log(res);
      // }).catch(err=>{})
    },
    // 排序
    sortChange(column, prop) {
      if (prop == 'name') {
        if (column.order == 'descending') {
          this.seek.sortNum = 2
        } else {
          this.seek.sortNum = 1
        }
      } else if (prop == 'did') {
        if (column.order == 'descending') {
          this.seek.sortNum = 4
        } else {
          this.seek.sortNum = 3
        }
      } else if (prop == 'mname') {
        if (column.order == 'descending') {
          this.seek.sortNum = 6
        } else {
          this.seek.sortNum = 5
        }
      } else if (prop == 'protocol') {
        if (column.order == 'descending') {
          this.seek.sortNum = 8
        } else {
          this.seek.sortNum = 7
        }
      } else if (prop == 'dsn') {
        if (column.order == 'descending') {
          this.seek.sortNum = 8
        } else {
          this.seek.sortNum = 7
        }
      } else {
        this.seek.sortNum = ''
      }
    },
    //表格状态
    GetStatus(status) {
      return {
        status: status == 1 ? 'success' : 'danger',
        TagName: status == 1 ? this.$t("lang.devicelist.connected") : this.$t("lang.devicelist.not")
      }
    },
    // 点击返回，返回到项目列表
    goBack() {
      this.$store.dispatch('setDevice', '')
      this.$router.push({
        path: `/cloudMonitor/deviceManagement/deviceList`,
      })
    },
    showVariable(row) {
      // console.log(row);
      this.$store.dispatch('setTerminalId', row)
      this.$router.push({
        path: `/cloudMonitor/deviceManagement/variableList`,
      })
    }
  }
}
</script>
